'use client'

import { useShare } from '../../../shared/hooks/use-share'
import { ArrowBackButton } from '../../../shared/ui-kit/actual/ArrowBackButton'
import { ProfileHeader } from '../../../shared/ui-kit/actual/ProfileHeader'
import { FlexRow } from '../../../shared/ui-kit/projectComponents'
import { H1 } from '../../../shared/ui-kit/titles'
import { AppProvider } from '../../providers/AppProvider/AppProvider'

function Header({ title }: { title: string }) {
  const { share } = useShare({
    shareFn: () => null,
    text: 'Можно взять в аренду!',
    title: 'Интересный товар',
  })

  return (
    <ProfileHeader
      center={<H1>{title}</H1>}
      left={<ArrowBackButton />}
      right={
        <FlexRow onClick={share} style={{ gap: '16px' }}>
          <img alt={'share'} src={'/images/buttons/share.svg'} />
        </FlexRow>
      }
    />
  )
}

export function ItemMobileHeaderClient({ title }: { title: string }) {
  return (
    <AppProvider>
      <Header title={title} />
    </AppProvider>
  )
}
